export default __webpack_public_path__ + "static/media/forever.4b96e4ff.svg";